import { r as registerInstance, h, H as Host, g as getElement } from './index-aa456b4c.js';

const fdsAlertBlockCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.fds-alert-block header{position:relative;display:flex;align-items:center;font-weight:bold}.fds-alert-block header>div{margin-right:3rem}.fds-alert-block header.isCloseable,.fds-alert-block header.isCollapsable{padding-right:2rem}.fds-alert-block header .close,.fds-alert-block header .collapse{color:rgba(0, 0, 0, 0.7);background-color:transparent;border:transparent;position:absolute;top:calc(50% - 0.5rem);top:50%;right:1rem;transform:translate3d(0.75rem, calc(-50% - 0.125rem), 0);cursor:pointer;display:flex;justify-content:center;align-items:center;margin-left:auto;padding:0;transition:border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;border-radius:4px}.fds-alert-block header .close:hover,.fds-alert-block header .close:focus,.fds-alert-block header .collapse:hover,.fds-alert-block header .collapse:focus{background-color:rgba(0, 0, 0, 0.0475)}.fds-alert-block header .close:active,.fds-alert-block header .collapse:active{background-color:rgba(0, 0, 0, 0.12)}.fds-alert-block header .collapse svg{transition:all 0.3s ease-in-out;transform:rotate(90deg)}.fds-alert-block header .collapse.open svg{transform:rotate(-90deg)}.fds-alert-block header .fds-alert-block__warning-icon{color:#B74E06;margin-right:0.5rem;flex:none}.fds-alert-block__content{text-align:left;margin-top:1rem}.fds-alert-block__content p:last-child{margin-bottom:0}.fds-alert-block__content.collapsed{display:none}.fds-alert-block.alert--info{display:block;padding:1rem 1rem 1.5rem;border-radius:4px;background-color:rgba(12, 72, 153, 0.0475);margin-bottom:1rem}.fds-alert-block.alert--info.collapsed{padding:1rem}.fds-alert-block.alert--warning{display:block;padding:1rem 1rem 1.5rem;border-radius:4px;background-color:#FFE385;margin-bottom:1rem;border:1px solid #FFD04A}.fds-alert-block.alert--warning a{color:rgba(0, 0, 0, 0.895)}.fds-alert-block.alert--error{display:block;padding:1rem 1rem 1.5rem;border-radius:4px;background-color:#E31C0D;margin-bottom:1rem;border:1px solid #A41107;color:rgba(0, 0, 0, 0.7)}.fds-alert-block.alert--error .close svg{fill:rgba(0, 0, 0, 0.7)}.fds-alert-block.hidden{display:none}";

const FdsAlertBlock = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.variant = 'info';
    this.label = undefined;
    this.epxandLabel = undefined;
    this.closeable = false;
    this.collapsable = false;
    this.expanded = true;
    this.locale = 'sv';
    this.open = true;
    this.visible = true;
    this.handleClose = this.handleClose.bind(this);
    this.handleCollapse = this.handleCollapse.bind(this);
  }
  componentWillLoad() {
    this.open = this.expanded;
    if (!this.el.id) {
      console.error(`<fds-alert-block>: ID is required.`);
    }
  }
  handleClose() {
    this.visible = !this.visible;
  }
  handleCollapse() {
    this.open = !this.open;
  }
  getWarningIcon() {
    if (this.variant == 'warning') {
      return (h("span", { class: "fds-alert-block__warning-icon" }, h("fds-icon", { name: "alert", size: "24" })));
    }
    else {
      return null;
    }
  }
  getCollapsableIcon() {
    let ariaLabel;
    if (this.open) {
      ariaLabel = this.locale === 'sv' ? 'Visa mindre' : 'Show less';
    }
    else {
      ariaLabel = this.locale === 'sv' ? 'Visa mer' : 'Show more';
    }
    if (!this.closeable && this.collapsable) {
      if (this.el.children.length > 0) {
        return (h("button", { class: { 'collapse': true, 'open': this.open }, onClick: this.handleCollapse, "aria-label": ariaLabel, "aria-expanded": this.el.children.length > 0 ? (this.open ? 'true' : 'false') : null, "aria-controls": this.el.children.length > 0 ? `section-${this.el.id}` : null }, h("fds-icon", { name: "arrowRight" })));
      }
      else {
        console.error(`<fds-alert-block>: The alert block has no content that can be expanded.`);
        return null;
      }
    }
    else {
      return null;
    }
  }
  getCloseIcon() {
    let ariaLabel = this.locale === 'sv' ? 'Stäng' : 'Close';
    if (this.closeable) {
      return (h("button", { class: "close", onClick: this.handleClose, "aria-label": ariaLabel }, h("fds-icon", { name: "cross" })));
    }
    else {
      return null;
    }
  }
  getHeaderSection() {
    return (h("header", { class: {
        'isCloseable': this.closeable,
        'isCollapsable': this.collapsable
      }, id: `heading-${this.el.id}` }, this.getWarningIcon(), this.label, this.getCloseIcon(), this.getCollapsableIcon()));
  }
  /**
   * If the interaction block has any content, then render the content section
   */
  setContent() {
    if (this.el.children.length > 0) {
      const openBlock = (this.collapsable && this.open) || !this.collapsable ? 'expanded' : 'collapsed';
      return (h("div", { class: `fds-alert-block__content ${openBlock}`, id: `section-${this.el.id}`, "aria-hidden": this.collapsable && this.open ? 'false' : 'true' }, h("slot", null)));
    }
    else {
      return null;
    }
  }
  render() {
    const { variant, visible } = this;
    const showBlock = visible ? 'visible' : 'hidden';
    const openBlock = (this.collapsable && this.open) || !this.collapsable ? 'expanded' : 'collapsed';
    return (h(Host, { class: `fds-alert-block alert--${variant} ${showBlock} ${openBlock}`, role: "alert" }, this.getHeaderSection(), this.setContent()));
  }
  get el() { return getElement(this); }
};
FdsAlertBlock.style = fdsAlertBlockCss;

export { FdsAlertBlock as fds_alert_block };
